<template lang="pug">
	section#prouni
		.wrapper
			h2 Boa Bolsa
			p
				| Conheça o BoaBolsa UniFAEL! Um programa que o aluno/candidato ganha muito mais que descontos.
				| Concorre a prêmios, novos cursos e até pode gerar uma renda extra com as indicações.
				| É o seu novo negócio com investimento zero. Confira!
			a(href="https://boabolsa.com.br/fael/ ").saibamais Saiba mais
</template>

<script>
	export default {
		name: "section-prouni"
	}
</script>

<style lang="stylus" scoped src="./BoaBolsa.styl"></style>
